<template>
    <div class="condition">
        <div class="van-hairline--bottom">
            <van-field readonly clickable name="picker" :value="cValue" placeholder="点击选择城市" @click="cShowPicker = true" />
            <van-popup v-model="cShowPicker" position="bottom">
                <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="cShowPicker = false" />
            </van-popup>
            <van-field readonly clickable name="picker" :value="type" placeholder="点击选择城市" @click="typeShowPicker = true" />
            <van-popup v-model="typeShowPicker" position="bottom">
                <van-picker show-toolbar :columns="typeData" @confirm="onTypeConfirm" @cancel="typeShowPicker = false" />
            </van-popup>
            <van-field v-model="input" size="large" placeholder="请输入内容" @input="inpFun" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cValue: "与",
            cValueKey: "AND",
            columns: [
                { text: "与", key: "AND" },
                { text: "或", key: "OR" },
                { text: "非", key: "NOT" }
            ],
            cShowPicker: false,
            type: "标题",
            typeKey: "TI",
            typeShowPicker: false,
            typeData: [
                { label: "TI", text: "标题" },
                { label: "TS", text: "主题" },
                // { label: "UN", text: "机构" },
                { label: "AU", text: "作者" },
                { label: "TA", text: "刊名" },
                { label: "MH", text: "主题词" },
                { label: "SH", text: "副主题词" },
                { label: "PMID", text: "PMID" },
                { label: "DOI", text: "DOI" },
                { label: "UNIT", text: "单位" }
            ],
            input: ""
        };
    },
    created() {},
    mounted() {},
    methods: {
        onConfirm(value) {
            this.cValue = value.text;
            this.cValueKey = value.key;
            this.cShowPicker = false;
        },
        onTypeConfirm(value) {
            this.type = value.text;
            this.typeKey = value.label;
            this.typeShowPicker = false;
        },
        inpFun(val) {
            console.log(val);
        }
    }
};
</script>
<style lang="less">
.condition {
    > div > div {
        font-size: 0.74667rem;
        line-height: 1.28rem;
        padding: 0.53333rem 0.85333rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .van-cell--clickable {
        width: 25%;
        display: inline-block;
        background: url("../../assets/img/dao.png") no-repeat;
        background-position: right 1.3rem;
        // padding: 0 15px;
    }

    .van-cell--clickable:nth-child(1) {
        width: 12%;
    }
    .van-cell--clickable:nth-child(2) {
        margin-left: 3%;
    }

    .van-cell--large {
        width: 60%;
        display: inline-block;
    }
}
</style>
